import * as React from "react";
import { cn } from "@/lib/utils";

export interface FormInputProps extends React.ComponentProps<"input"> {
  label: string;
  error?: string;
  containerClassName?: string;
  required?: boolean;
}

export const FormInput = React.forwardRef<HTMLInputElement, FormInputProps>(
  ({ label, error, id, className, containerClassName, required, ...props }, ref) => {
    const inputId = id || React.useId();
    const isDisabled = props.disabled;
    return (
      <div className={cn("flex w-full flex-col gap-2", containerClassName)}>
        <label
          htmlFor={inputId}
          className={cn(
            "font-sans text-[14px] leading-[18px]",
            isDisabled ? "text-text-muted" : "text-text-primary",
          )}
        >
          {label}
          {required && <span className="ml-1 text-text-primary">*</span>}
        </label>
        <input
          ref={ref}
          id={inputId}
          required={required}
          className={cn(
            "w-full rounded-[6px] border bg-surface-warm px-4 py-5",
            "border-[color-mix(in_oklab,var(--primary-200)_40%,transparent)]",
            "font-sans text-[16px] leading-[22px] font-light text-text-primary",
            "placeholder:text-[color-mix(in_oklab,var(--text-muted)_60%,transparent)]",
            "transition-colors focus-visible:outline-none focus-visible:border-primary-400",
            "disabled:cursor-not-allowed disabled:bg-[color-mix(in_oklab,var(--primary-100)_50%,transparent)] disabled:border-primary-200 disabled:text-text-muted disabled:placeholder:text-[color-mix(in_oklab,var(--text-muted)_60%,transparent)]",
            error && "border-destructive focus-visible:border-destructive placeholder:text-destructive",
            className,
          )}
          {...props}
        />
        {error && (
          <p className="font-sans text-[12px] leading-[16px] font-light text-destructive">
            {error}
          </p>
        )}
      </div>
    );
  },
);
FormInput.displayName = "FormInput";